import PredkladatelUpdate from './PredkladatelUpdate';

export default PredkladatelUpdate;
